import { Grid } from '@backstage/ui';
import {
  EntitySwitch,
  EntityOrphanWarning,
  EntityProcessingErrorsPanel,
  hasCatalogProcessingErrors,
  isOrphan,
  hasRelationWarnings,
  EntityRelationWarning,
} from '@backstage/plugin-catalog';

export const EntityWarningContent = (
  <>
    <EntitySwitch>
      <EntitySwitch.Case if={isOrphan}>
        <Grid.Item colSpan="12">
          <EntityOrphanWarning />
        </Grid.Item>
      </EntitySwitch.Case>
    </EntitySwitch>
    <EntitySwitch>
      <EntitySwitch.Case if={hasRelationWarnings}>
        <Grid.Item colSpan="12">
          <EntityRelationWarning />
        </Grid.Item>
      </EntitySwitch.Case>
    </EntitySwitch>
    <EntitySwitch>
      <EntitySwitch.Case if={hasCatalogProcessingErrors}>
        <Grid.Item colSpan="12">
          <EntityProcessingErrorsPanel />
        </Grid.Item>
      </EntitySwitch.Case>
    </EntitySwitch>
  </>
);
